import isNaN from 'lodash/isNaN';
import isNil from 'lodash/isNil';

export const NumberHelper = {
  toNumberOrUndefined: (value?: unknown): number | undefined => {
    return !isNil(value) && !isNaN(value) ? Number(value) : undefined;
  }
};
